// src/App.tsx

import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import Login from './components/Login';
import SignUp from './components/SignUp';
import Home from './components/Home';
import Chat from './components/Chat';
import Reports from './components/Reports';
import ProtectedRoute from './components/ProtectedRoute';
import { AuthProvider } from './contexts/AuthContext';
import { ApiKeysProvider } from './contexts/ApiKeysContext';
import AddApiKeys from './components/AddApiKeys';
import Feedback from './components/Feedback'; // Import the new Feedback component

const App: React.FC = () => {
    return (
        <AuthProvider>
            <ApiKeysProvider>
                <Router>
                    <Header />
                    <Routes>
                        <Route path="/" element={<Home />} />
                        <Route
                            path="/reports"
                            element={
                                <ProtectedRoute>
                                    <Reports />
                                </ProtectedRoute>
                            }
                        />
                        <Route
                            path="/chat"
                            element={
                                <ProtectedRoute>
                                    <Chat />
                                </ProtectedRoute>
                            }
                        />
                        <Route
                            path="/add-api-keys"
                            element={
                                <ProtectedRoute>
                                    <AddApiKeys />
                                </ProtectedRoute>
                            }
                        />
                        <Route
                            path="/feedback"
                            element={
                                <ProtectedRoute>
                                    <Feedback />
                                </ProtectedRoute>
                            }
                        />
                        <Route path="/login" element={<Login />} />
                        <Route path="/signup" element={<SignUp />} />
                    </Routes>
                </Router>
            </ApiKeysProvider>
        </AuthProvider>
    );
};

export default App;
